import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, of, switchMap, take } from 'rxjs';
import { RegisterLoginModes } from '../dialogs/register-login/register-login.dialog';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  return auth.isLoggedIn$.pipe(
    take(1), // only take the latest value once
    switchMap(isLoggedIn => {
      if (isLoggedIn) {
        return of(true);
      } else {
        return auth.openDialog(RegisterLoginModes.TabLogin)
          .afterClosed()
          .pipe(
            take(1),
            switchMap(() => {
              return auth.isLoggedIn$.pipe(take(1))
            })
          )
      }
    })
  );
}

